import { useState, useEffect } from 'react';

/**
 * 轻量 Toast 存储（模块级，无 Context）：任何位置可 toast()，
 * ToastHost 订阅渲染。3.5s 自动消失；测试中 mock 本模块的 toast 即可断言。
 */

export type ToastKind = 'success' | 'error' | 'info';

export interface ToastItem {
  id: number;
  kind: ToastKind;
  text: string;
}

const AUTO_DISMISS_MS = 3500;

let nextId = 1;
let items: ToastItem[] = [];
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export function dismiss(id: number) {
  items = items.filter((t) => t.id !== id);
  emit();
}

export function toast(text: string, kind: ToastKind = 'info') {
  const item: ToastItem = { id: nextId++, kind, text };
  items = [...items, item];
  emit();
  window.setTimeout(() => dismiss(item.id), AUTO_DISMISS_MS);
  return item.id;
}

export function useToasts(): ToastItem[] {
  const [list, setList] = useState<ToastItem[]>(items);
  useEffect(() => {
    const subscribe = () => setList([...items]);
    listeners.add(subscribe);
    subscribe();
    return () => {
      listeners.delete(subscribe);
    };
  }, []);
  return list;
}
